var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"download"},_vm._l((_vm.downloadList),function(item,i){return _c('div',{key:i},[_c('a',{staticClass:"download_box",attrs:{"target":"_blank","href":item.url},on:{"click":function($event){return _vm.track(item.trackDevice)}}},[_c('img',{staticClass:"download_box",attrs:{"src":_vm.ptDownloadImage(item.imageUrl)}})])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }